import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw0113f1Api } from '../../../services/pw0113f1Api';

export function usePW0113F1Form() {
  const [loading, setLoading] = useState(false);

  // Form fields
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // Reset form
  const resetForm = useCallback(() => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  }, []);

  // Submit password change
  const submit = useCallback(async (): Promise<boolean> => {
    setLoading(true);
    try {
      const resp = await pw0113f1Api.changePassword({
        oldPassword,
        newPassword,
        confirmPassword,
      });
      if (resp.success) {
        message.success(resp.message || '密碼修改成功');
        resetForm();
        return true;
      }
      return false;
    } catch (err: any) {
      const vErrs = err?.response?.data?.errors;
      if (vErrs && Array.isArray(vErrs)) {
        vErrs.forEach((e: any) => message.error(e.message));
      } else {
        message.error(err?.response?.data?.error || '密碼修改失敗');
      }
      return false;
    } finally {
      setLoading(false);
    }
  }, [oldPassword, newPassword, confirmPassword, resetForm]);

  return {
    loading,
    oldPassword, setOldPassword,
    newPassword, setNewPassword,
    confirmPassword, setConfirmPassword,
    submit, resetForm,
  };
}
